import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { http, refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams((location.hash || "").replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/entrar", { replace: true });
      return;
    }

    (async () => {
      try {
        await http.post("/auth/session", { session_id: sessionId });
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        navigate("/", { replace: true });
      } catch (e) {
        setError("Não foi possível concluir o login com Google. Tente novamente.");
      }
    })();
  }, [location.hash, http, refresh, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center bg-[#05050A]">
      {error ? (
        <>
          <p className="text-slate-300">{error}</p>
          <button onClick={() => navigate("/entrar", { replace: true })}
            className="mt-4 px-6 py-3 rounded-2xl bg-[#F43F5E] font-semibold text-white">Voltar ao login</button>
        </>
      ) : (
        <>
          <Loader2 className="w-10 h-10 animate-spin text-[#F43F5E] mb-5" />
          <p className="font-display font-bold text-xl">Entrando…</p>
          <p className="text-slate-400 mt-1">Finalizando seu login com o Google</p>
        </>
      )}
    </div>
  );
}
